export const RuleTargetingDescriptions = {
  type: "Targeting domain — what the conditions are about: cart contents, the viewed product, the visitor, or the page. Determines how the expression is typed and which evaluator runs it.",
  expression:
    "Boolean expression tree of conditions for this domain. Each node has either a 'query' (leaf) or 'operator' (combinator).",
} as const;
